import { controlDefaults } from '../../core/form/lib/validateForm';

export const clientControls = {
  id: {
    ...controlDefaults,
    name: 'id',
    type: 'hidden',
  },
  analysis_period_id: {
    ...controlDefaults,
    name: 'analysis_period_id',
    fieldName: 'period.description',
    sortColumn: 'period.date',
    type: 'select',
    caption: 'Period',
    validationRules: {
      isRequired: true,
    },
    width: 200,
    showInEditor: true,
    showInListview: true,
  },
  client_status_id: {
    ...controlDefaults,
    name: 'client_status_id',
    fieldName: 'client_status.name',
    type: 'select',
    caption: 'Client Status',
    classesFromRowPath: 'client_status.classes',
    validationRules: {
      isRequired: false,
    },
    width: 200,
    showInListview: true,
    showInEditor: true,
    isEditable: true
  },
};

export const adminControls = {
  ...clientControls,
  rcs_status_id: {
    ...controlDefaults,
    name: 'rcs_status_id',
    fieldName: 'rcs_status.name',
    type: 'select',
    caption: 'RCS Status',
    validationRules: {
      isRequired: false,
    },
    width: 250,
    showInListview: true,
    showInEditor: true,
    isEditable: true
  },
  percentage_completed: {
    ...controlDefaults,
    placeholder: '',
    name: 'percentage_completed',
    fieldName: 'percentage_completed',
    caption: 'Completed (%)',
    type: 'number',
    validationRules: {
      isRequired: true,
    },
    width: 150,
    showInListview: true,
    showInEditor: true,
    isEditable: true
  },
  report_sent: {
    ...controlDefaults,
    placeholder: '',
    name: 'report_sent',
    fieldName: 'report_sent',
    caption: 'Report Sent',
    type: 'date',
    validationRules: {
      isRequired: false,
    },
    width: 150,
    showInListview: true,
    showInEditor: true,
    isEditable: true
  },
  period_dnc: {
    ...controlDefaults,
    name: 'period_dnc',
    fieldName: 'period_dnc',
    type: 'checkbox',
    caption: 'DNC',
    descriptionStatus: { switchOn: 'Yes', switchOff: 'No' },
    showInListview: true,
    showInEditor: true,
    controlType: 'switch',
    width: 50,
    isEditable: true
  },
  comment: {
    ...controlDefaults,
    name: 'comment',
    fieldName: 'comment',
    type: 'textarea',
    caption: 'Comment',
    showInListview: true,
    showInEditor: true,
    isEditable: true
  }
};
